export const SELFIE_CHALLENGE_SUCCESS = 'SELFIE_CHALLENGE_SUCCESS';
